import type { FontFaceSpec } from '../../types';
import woff2 from '../src/PPMori-SemiBoldItalicNew.woff2';
import woff from '../src/PPMori-SemiBoldItalicNew.woff';

export const ppMoriSemiBoldItalic: FontFaceSpec = {
  weight: 600,
  style: 'italic',
  src: [
    { file: woff2, format: 'woff2' },
    { file: woff, format: 'woff' },
  ],
};
